import { Component, Input } from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';

@Component({
  selector: 'crm-form-field-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss'],
  viewProviders: [provideTranslation('formFieldFile', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldFileComponent extends FormFieldAbstractComponent {
  @Input() accept?: string;

  selectedFiles: string[] = [];

  fileChanged(e: Event): void {
    const files = (e.target as any).files;
    this.getFormControl().setValue(files);

    if (!files || files.length === 0) {
      this.selectedFiles = [];
      return;
    }

    Array.from(files).forEach((file: File) => this.selectedFiles.push(file.name));
  }
}
